function Cartographie() {
  return (
    <div style={{ textAlign: "center", marginTop: "2em" }}>
      <h1>Carto</h1>
    </div>
  );
}

export default Cartographie;
